var classes = {"label":"index-module_label__xPV4V","hasError":"index-module_hasError__GZv51"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
